// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { slideshowStyles } from "@monsma/Overrides/Widgets/Basic/Slideshow";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

slideshowStyles.slideShowWrapper = {
    css: css`
        ${slideshowStyles.slideShowWrapper?.css}
        ${screen("lt", "xs")} {
            &&& {
                .swiper-navigation {
                    bottom: 30px;
                    left: 50%;
                    transform: translateX(-50%);
                }
            }
        }
    `,
};

slideshowStyles.slideButton = {
    css: css`
        ${screen("lt", "xs")} {
            margin-bottom: 50px;
        }
    `,
};
